import { render, staticRenderFns } from "./StartForm.vue?vue&type=template&id=516b5a1a&scoped=true&"
import script from "./StartForm.vue?vue&type=script&lang=js&"
export * from "./StartForm.vue?vue&type=script&lang=js&"
import style0 from "./StartForm.vue?vue&type=style&index=0&id=516b5a1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516b5a1a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\carli\\Documents\\Github\\Sharo Employee New\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('516b5a1a')) {
      api.createRecord('516b5a1a', component.options)
    } else {
      api.reload('516b5a1a', component.options)
    }
    module.hot.accept("./StartForm.vue?vue&type=template&id=516b5a1a&scoped=true&", function () {
      api.rerender('516b5a1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/User/StartForm/StartForm.vue"
export default component.exports